export const MODAL_PAGE_RENDERED = 'MODAL_PAGE_RENDERED';

export const modalPageRendered = () => ({
	type: MODAL_PAGE_RENDERED,
});
